import { useState } from "react";
import { useFormik } from "formik";
import InfoIcon from "@mui/icons-material/Info";
import InputAdornment from "@mui/material/InputAdornment";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import { Button, Grid, InputLabel, Typography, Box, CircularProgress } from "@mui/material";
import NocDetail from "./NocDetails";
import ApiClient from "helpers/ApiClient";
import { validationSchema, initialValues } from "./validation";
import "./styles.scss";

const EmployeeVerification = ({ companyId, setToggleSnackbar }: any) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [supportModal, setSupportModal] = useState(false);

  const { values, errors, setFieldValue, touched, handleChange, handleSubmit, handleBlur } =
    useFormik({
      initialValues,
      validationSchema,
      onSubmit: () => {
        uploadProof(values);
      },
    });

  const uploadProof = ({ relationToCompany, file }: any) => {
    setIsLoading(true);
    let uploadProofData = new FormData();
    uploadProofData.append("companyId", companyId);
    uploadProofData.append("relationshipWithCompany", relationToCompany);
    uploadProofData.append("file", file);

    ApiClient.post("company/upload", uploadProofData)
      .then((res) => {
        setIsLoading(false);
        setIsSubmitted(true);
      })
      .catch((err) => {
        setIsLoading(false);
        const error = err.response.data.message;
        setToggleSnackbar({ message: error, isToggle: true, mode: "error", top: "110px" });
      });
  };

  return (
    <Box className="vehicle-registration">
      {!isSubmitted && (
        <form onSubmit={handleSubmit}>
          <Typography variant="h5" sx={{ mb: "20px", color: "#434242", fontWeight: "500" }}>
            Employment Verfication
          </Typography>
          <Grid container spacing={2} rowSpacing={4}>
            <Grid item md={12} sm={12} xs={12} sx={{ position: "relative" }}>
              <InputLabel
                htmlFor="relationToCompany"
                className={
                  errors.relationToCompany && touched.relationToCompany ? "label-err" : "label"
                }
              >
                Relationship to Company <span style={{color:'red'}}>*</span>
              </InputLabel>
              <FormControl fullWidth>
                <Select
                  name="relationToCompany"
                  sx={{ background: "#fff" }}
                  size="small"
                  displayEmpty
                  value={values.relationToCompany}
                  onBlur={handleBlur}
                  error={!!(errors.relationToCompany && touched.relationToCompany)}
                  onChange={handleChange}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={"Owner"}>Owner</MenuItem>
                  <MenuItem value={"Employee"}>Employee</MenuItem>
                </Select>
                {errors.relationToCompany && touched.relationToCompany && (
                  <InfoIcon
                    fontSize="medium"
                    sx={{ color: "#DC3545", position: "absolute", top: "9px", right: "11px" }}
                  />
                )}
              </FormControl>
              {errors.relationToCompany && touched.relationToCompany && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.relationToCompany}
                </Typography>
              )}
            </Grid>
            {values.relationToCompany && (
              <Grid item md={12} sm={12} sx={{ width: "100%" }}>
                <InputLabel
                  htmlFor="file"
                  className={errors.file && touched.file ? "label-err" : "label"}
                >
                  {values.relationToCompany === "Owner"
                    ? "Proof of Ownership"
                    : "Proof of Employment"} <span style={{color:'red'}}>*</span>
                </InputLabel>

                <TextField
                  sx={{ background: "#fff" }}
                  fullWidth
                  onChange={(e: any) => setFieldValue("file", e.target.files[0])}
                  error={!!(errors.file && touched.file)}
                  type="file"
                  size="small"
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {errors.file && touched.file ? (
                          <InfoIcon sx={{ color: "#DC3545" }} fontSize="medium" />
                        ) : (
                          <CloudUploadIcon />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />

                {errors.file && touched.file && (
                  <Typography sx={{ color: "#DC3545" }} variant="body2">
                    {errors.file}
                  </Typography>
                )}
              </Grid>
            )}
            <Grid item md={12} sm={12} xs={12}>
              <Box sx={{ textAlign: "right" }}>
                <Button
                  type="submit"
                  sx={{ width: { xs: "100%", md: "auto" } }}
                  className="btn-primary"
                  disableRipple
                  variant="contained"
                >
                  {isLoading ? (
                    <>
                      <CircularProgress size={20} sx={{ color: "#FFFFFF", mr: 1 }} />
                      <span> Loading...</span>
                    </>
                  ) : (
                    <span>Continue</span>
                  )}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      )}
      {isSubmitted && (
        <NocDetail
          open={supportModal}
          onOpen={() => setSupportModal(true)}
          onClose={() => setSupportModal(false)}
        />
      )}
    </Box>
  );
};
export default EmployeeVerification;
